"use strict";

var _interopRequireWildcard = require("/Users/vagrant/git/node_modules/@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("/Users/vagrant/git/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.function.name");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.regexp.to-string");

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("/Users/vagrant/git/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _user = require("@/api/user");

var _auth = require("@/utils/auth");

var _router = _interopRequireWildcard(require("@/router"));

var _auth2 = require("../../utils/auth");

var _utils = require("@/utils");

var _apolloClient = require("@/apollo/apolloClient");

var _companyQuery = require("@/apollo/queries/company-query");

var _enums = require("../../utils/enums");

var firebase = require('firebase');

var state = {
  token: (0, _auth.getToken)(),
  name: '',
  avatar: '',
  introduction: '',
  roles: [],
  company_code: (0, _auth2.getCompanyCode)(),
  company_uid: (0, _auth2.getUserUID)(),
  redirect: '',
  user: []
};
var mutations = {
  SET_TOKEN: function SET_TOKEN(state, token) {
    state.token = token;
  },
  SET_INTRODUCTION: function SET_INTRODUCTION(state, introduction) {
    state.introduction = introduction;
  },
  SET_NAME: function SET_NAME(state, name) {
    state.name = name;
  },
  SET_AVATAR: function SET_AVATAR(state, avatar) {
    state.avatar = avatar;
  },
  SET_ROLES: function SET_ROLES(state, roles) {
    state.roles = roles;
  },
  SET_COMPANY_CODE: function SET_COMPANY_CODE(state, company_code) {
    state.company_code = company_code;
  },
  SET_COMPANY_UID: function SET_COMPANY_UID(state, company_uid) {
    state.company_uid = company_uid;
  },
  SET_REDIRECT: function SET_REDIRECT(state, redirect) {
    state.redirect = redirect;
  },
  SET_FIREBASE_USER: function SET_FIREBASE_USER(state, user) {
    state.user = user;
  }
};
var actions = {
  // user login
  login: function () {
    var _login = (0, _asyncToGenerator2.default)(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee4(_ref, userInfo) {
      var commit, checkUserRoleAndSetRoute, _checkUserRoleAndSetRoute, id, password, company_id, loginFunctions, loginRespond;

      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _checkUserRoleAndSetRoute = function _ref5() {
                _checkUserRoleAndSetRoute = (0, _asyncToGenerator2.default)(
                /*#__PURE__*/
                regeneratorRuntime.mark(function _callee3() {
                  var errorRoleMessage, res, role, routeNames;
                  return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                      switch (_context3.prev = _context3.next) {
                        case 0:
                          errorRoleMessage = 'ログイン権限がありません。';
                          _context3.next = 3;
                          return _apolloClient.apolloClient.query({
                            query: _companyQuery.GET_USER_BY_UID,
                            variables: {
                              uid: firebase.auth().currentUser.uid
                            }
                          });

                        case 3:
                          res = _context3.sent;

                          if (!res.errors) {
                            _context3.next = 6;
                            break;
                          }

                          throw res.errors[0].message;

                        case 6:
                          role = res.data.user.role;

                          if (role.get_can_use_admin_site) {
                            _context3.next = 11;
                            break;
                          }

                          return _context3.abrupt("return", Promise.reject(errorRoleMessage));

                        case 11:
                          if (!(_enums.allAdminPermissionAndRouter.some(function (item) {
                            return role[item.nameData];
                          }) === false)) {
                            _context3.next = 13;
                            break;
                          }

                          return _context3.abrupt("return", Promise.reject(errorRoleMessage));

                        case 13:
                          routeNames = [];

                          if (role) {
                            _enums.allAdminPermissionAndRouter.forEach(function (item) {
                              if (!role[item.nameData]) {
                                item.pathNames.forEach(function (i) {
                                  return routeNames.push(i);
                                });
                              }
                            });

                            if (!role.admin_user_view && !role.admin_bulletin_add && !role.admin_user_import) {
                              routeNames.push('Company');
                            }

                            if (!role.admin_bulletin_view && !role.admin_bulletin_add && !role.admin_bulletin_category_edit) {
                              routeNames.push('Bulletin');
                            }

                            if (!role.admin_suggestion_view && !role.admin_suggestion_category_edit) {
                              routeNames.push('Suggestion');
                            }

                            (0, _auth2.setRoles)(JSON.stringify(routeNames));
                            (0, _auth2.setUserPermission)(JSON.stringify(role));
                          }

                        case 15:
                        case "end":
                          return _context3.stop();
                      }
                    }
                  }, _callee3);
                }));
                return _checkUserRoleAndSetRoute.apply(this, arguments);
              };

              checkUserRoleAndSetRoute = function _ref4() {
                return _checkUserRoleAndSetRoute.apply(this, arguments);
              };

              commit = _ref.commit;
              id = userInfo.id, password = userInfo.password, company_id = userInfo.company_id; // ------->ここから

              loginFunctions = firebase.app().functions('asia-northeast1');
              loginRespond = loginFunctions.httpsCallable('adminLogin');
              _context4.next = 8;
              return loginRespond({
                user_id: id.toString().trim(),
                password: (0, _user.encrypt)(password.toString().trim()),
                zone_id: company_id.toString().trim()
              }).then(
              /*#__PURE__*/
              function () {
                var _ref2 = (0, _asyncToGenerator2.default)(
                /*#__PURE__*/
                regeneratorRuntime.mark(function _callee2(result) {
                  return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          if (!(result.data.code === 200)) {
                            _context2.next = 13;
                            break;
                          }

                          _context2.next = 3;
                          return firebase.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL).then(
                          /*#__PURE__*/
                          (0, _asyncToGenerator2.default)(
                          /*#__PURE__*/
                          regeneratorRuntime.mark(function _callee() {
                            var checkClaim;
                            return regeneratorRuntime.wrap(function _callee$(_context) {
                              while (1) {
                                switch (_context.prev = _context.next) {
                                  case 0:
                                    // check claim in token
                                    checkClaim = (0, _utils.claimTokenInLogin)(result.data.login_token);
                                    (0, _auth2.setZoneId)(checkClaim);

                                    if (!(checkClaim === 'no-claim')) {
                                      _context.next = 5;
                                      break;
                                    }

                                    console.log('TokenにClaimはありません');
                                    return _context.abrupt("return", Promise.reject('認証に失敗しました。'));

                                  case 5:
                                    _context.next = 7;
                                    return firebase.auth().signInWithCustomToken(result.data.login_token).catch(function (error) {
                                      return Promise.reject('認証に失敗しました。(' + error.data.code + ')');
                                    });

                                  case 7:
                                    return _context.abrupt("return", _context.sent);

                                  case 8:
                                  case "end":
                                    return _context.stop();
                                }
                              }
                            }, _callee);
                          }))).catch(function (error) {
                            return Promise.reject('認証に失敗しました。(' + error.code + ')');
                          });

                        case 3:
                          _context2.next = 5;
                          return checkUserRoleAndSetRoute().catch(function () {
                            return Promise.reject('サーバーに失敗しました。');
                          });

                        case 5:
                          commit('SET_TOKEN', 'admin-token');
                          commit('SET_REDIRECT', '/profile');
                          (0, _auth.setToken)('admin-token');
                          (0, _auth2.setCompanyCode)(result.data.company_id);
                          (0, _auth2.setUserUID)(result.data.uid);
                          return _context2.abrupt("return", Promise.resolve());

                        case 13:
                          return _context2.abrupt("return", Promise.reject(result.data.message));

                        case 14:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee2);
                }));

                return function (_x3) {
                  return _ref2.apply(this, arguments);
                };
              }()).catch(function (error) {
                return Promise.reject(error);
              });

            case 8:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    function login(_x, _x2) {
      return _login.apply(this, arguments);
    }

    return login;
  }(),
  setFirebaseUser: function () {
    var _setFirebaseUser = (0, _asyncToGenerator2.default)(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee5(_ref6, user) {
      var commit;
      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              commit = _ref6.commit;
              commit('SET_FIREBASE_USER', user);

            case 2:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    function setFirebaseUser(_x4, _x5) {
      return _setFirebaseUser.apply(this, arguments);
    }

    return setFirebaseUser;
  }(),
  // get user info
  getInfo: function getInfo(_ref7) {
    var commit = _ref7.commit,
        state = _ref7.state;
    return new Promise(function (resolve, reject) {
      (0, _user.getInfo)(state.token).then(function (response) {
        var data = response.data;

        if (!data) {
          reject('Verification failed, please Login again.');
        }

        var roles = data.roles,
            name = data.name,
            avatar = data.avatar,
            introduction = data.introduction;

        if (!roles || roles.length <= 0) {
          reject('getInfo: roles must be a non-null array!');
        }

        commit('SET_ROLES', roles);
        commit('SET_NAME', name);
        commit('SET_AVATAR', avatar);
        commit('SET_INTRODUCTION', introduction);
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  // user logout
  logout: function logout(_ref8) {
    var commit = _ref8.commit,
        state = _ref8.state;
    return new Promise(function (resolve, reject) {
      (0, _user.logout)(state.token).then(function () {
        commit('SET_TOKEN', '');
        commit('SET_ROLES', []);
        (0, _auth.removeSidebarStatus)();
        (0, _auth.removeSize)();
        (0, _auth.removeToken)();
        (0, _auth.removeCompanyCode)();
        (0, _auth.removePerCompanyCode)();
        (0, _auth.removeEventDetailCode)();
        (0, _auth.removePerEventCode)();
        (0, _auth.removeCouponCode)();
        (0, _auth.removeCouponCompanyCode)();
        (0, _auth.removeCouponEventCode)();
        (0, _auth.removeCouponIndexCode)();
        (0, _auth.removeCompanyUID)();
        (0, _router.resetRouter)();
        resolve();
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  // remove token
  resetToken: function resetToken(_ref9) {
    var commit = _ref9.commit;
    return new Promise(function (resolve) {
      commit('SET_TOKEN', '');
      commit('SET_ROLES', []);
      (0, _auth.removeSidebarStatus)();
      (0, _auth.removeSize)();
      (0, _auth.removeToken)();
      (0, _auth.removeCompanyCode)();
      (0, _auth.removePerCompanyCode)();
      (0, _auth.removeEventDetailCode)();
      (0, _auth.removePerEventCode)();
      (0, _auth.removeCouponCode)();
      (0, _auth.removeCouponCompanyCode)();
      (0, _auth.removeCouponEventCode)();
      (0, _auth.removeCouponIndexCode)();
      (0, _auth.removeCompanyUID)();
      resolve();
    });
  },
  // dynamically modify permissions
  changeRoles: function changeRoles(_ref10, role) {
    var commit = _ref10.commit,
        dispatch = _ref10.dispatch;
    return new Promise(
    /*#__PURE__*/
    function () {
      var _ref11 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee6(resolve) {
        var token, _ref12, roles, accessRoutes;

        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                token = role + '-token';
                commit('SET_TOKEN', token);
                (0, _auth.setToken)(token);
                _context6.next = 5;
                return dispatch('getInfo');

              case 5:
                _ref12 = _context6.sent;
                roles = _ref12.roles;
                (0, _router.resetRouter)(); // generate accessible routes map based on roles

                _context6.next = 10;
                return dispatch('permission/generateRoutes', roles, {
                  root: true
                });

              case 10:
                accessRoutes = _context6.sent;

                // dynamically add accessible routes
                _router.default.addRoutes(accessRoutes); // reset visited views and cached views


                dispatch('tagsView/delAllViews', null, {
                  root: true
                });
                resolve();

              case 14:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      return function (_x6) {
        return _ref11.apply(this, arguments);
      };
    }());
  },
  getUserRealTime: function () {
    var _getUserRealTime = (0, _asyncToGenerator2.default)(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee7(_ref13, user_id) {
      var commit, res;
      return regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              commit = _ref13.commit;
              _context7.next = 3;
              return _apolloClient.apolloClient.query({
                query: _companyQuery.GET_USER_BY_UID,
                variables: {
                  uid: user_id
                }
              });

            case 3:
              res = _context7.sent;

              if (!res.data) {
                _context7.next = 8;
                break;
              }

              return _context7.abrupt("return", res.data.user);

            case 8:
              throw res.errors[0].message;

            case 9:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }));

    function getUserRealTime(_x7, _x8) {
      return _getUserRealTime.apply(this, arguments);
    }

    return getUserRealTime;
  }()
};
var _default = {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};
exports.default = _default;